/**
 * @param {import('modules/squad/types').SquadMemberInfo} member
 */
export default function getMemberNameSquadUtil (member) {
  return (
    member?.squad_member_short_name ||
    member?.squad_member_first_name ||
    (member?.squad_member_customer_email || '').toLowerCase()
  )
}
